import IapiAuthDetails from '../../shared/Interfaces/apiAuthDetails';

const genRoute = (route: any, auth: IapiAuthDetails) =>
  route +
  '?CallerUserDetailID=' +
  auth.CallerUserDetailID +
  '&CallerFormID=' +
  auth.CallerFormID;

export {genRoute};
export default genRoute;
